export default function auth(state = {}, action) {
  const { type, data } = action;
  const matches = type === "AUTH";
  if (!matches) {
    return state;
  }
  return {
    ...state,
    ...data,
  };
}
